var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('v-icon',{staticClass:"icons",attrs:{"data-test":"type-icon"}},[_vm._v(" "+_vm._s(_vm.deviceIcon[_vm.iconName] || 'fl-tux')+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }